export const LeadDetailsHeader = "Lead Details";
export const TrackingInformationSubHeader = "Tracking Information";
export const ContactInformationSubHeader = "Contact Information";
export const ProjectInformationSubHeader = "Questionnaire Responses";
export const LeadNumberLabel = "Lead #";
export const AssignedToLocationLabel = "Assigned To Location";
export const AssignedToPersonLabel = "Assigned To Person";
export const LastUpdatedLabel = "Last Updated";
export const CreatedDateLabel = "Created Date";
export const ContactNameLabel = "Name";
export const ContactPhoneLabel = "Phone";
export const ContactEmailLabel = "Email";
export const ContactAddressLabel = "Address";
export const LeadDetailsCancel = "Cancel";
export const LeadDetailsSave = "Save";
export const LeadDetailsAccessDeniedHeader = "Whoops!";
export const LeadDetailsAccessDeniedErrorCode = "(Error Code: 403)";
export const LeadDetailsAccessDeniedText =
	"Seems as if you need permission to see what you are requesting. Please contact your Account Admin to remedy your access.";
export const LeadDetailsBackToList = "Back to My Leads";
export const LeadStatusLabel = "Lead Status";
export const DeclineReasonLabel = "Reason";
export const OrderNumberLabel = "Order #";
export const OrderNumberErrorText = "Order # is a required field";
export const FollowUpDateLabel = "Follow Up Date";
export const FollowUpDateErrorText = "Follow up date is required";
export const FollowUpDatePastErrorText = "Follow up date must be today or a future date";
export const LeadNotesLabel = "Lead Notes";
export const DeclineLeadModalTitle = "Why are you declining this lead?";
export const DeclineLeadInfoBannerTitle = "This will allow us to provide leads that better fit your needs.";
export const DeclineLeadCancelButtonText = "CANCEL";
export const DeclineLeadDeclineLead = "DECLINE LEAD";
export const DeclineReasonOutOfMarket = "Out of Market";
export const DeclineReasonJobSizeTooSmall = "Job Size Too Small";
export const DeclineReasonJobSizeTooBig = "Job Size Too Big";
export const DeclineReasonInsufficientStaff = "Insufficient Staff";
export const DeclineReasonNoRoomInCurrentSchedule = "No Room in Current Schedule";
export const DeclineReasonBrandNotSoldHere = "Brand Not Sold Here";
export const DeclineReasonIssueWithLead = "Issue with Lead";
export const SnackBarLoadingText = "Saving Lead Details...";
export const SnackBarSuccessText = "Lead saved successfully.";
export const SnackBarErrorText = "Failed to save lead changes. Please try again.";
